export var hostVersionsInfo = {
    // AdaptiveCard version can be found in the package.json of the adaptive-card-renderer control package
    adaptiveCardSchemaVersion: { majorVersion: 2, minorVersion: 11 },
};
//# sourceMappingURL=AppHostHostVersionsInfo.js.map